import {Component, Input, OnInit} from "@angular/core";
import {FUINavigationTree} from "./navigation-tree/navigation-tree.model";

@Component({
    selector: "fui-navigation-trees",
    templateUrl: "./navigation-trees.component.html",
    styleUrls: ["./navigation-trees.component.scss"]
})
export class FUINavigationTreesComponent implements OnInit {
    @Input() trees: FUINavigationTree[];

    constructor() {

    }

    ngOnInit() {

    }
}
